<template>
  <v-container>
     <v-card  class="mx-auto"
    
    outlined>
     <v-card-text>
     <h1 class="text-center ma-5" >Medical Records Collection Guide</h1>
     <p>  <v-btn @click='downloadPDF' rounded color="primary" dark>Download PDF <v-icon class='ml-1' medium>mdi-download</v-icon></v-btn></p> 
     <p class="text-center ma-10 font-weight-regular title">To help get you fill out your My Genetic Trust, we’ve put together this guide
with some helpful tips for collecting medical records.
</p>

<v-row class='ma-4'>
    <v-flex
                          xs12
                          sm7>
        <p class=' font-weight-bold mt-5 title'>
    Information that is helpful to get, if possible, includes:
</p>
        <li class='font-weight-regular title'>Genetic test results
</li>
<li  class='font-weight-regular title'>Notes from a clinic visit for a specific health concern</li>
<li  class='font-weight-regular title'>Pathology report from biopsies or cancer
diagnoses</li>
<li  class='font-weight-regular title'>Any history of intellectual or developmental delays</li>
<li  class='font-weight-regular title'>Death certificates/autopsy reports</li>
<li  class='font-weight-regular title'>Other lab test results</li>
    </v-flex>
    <v-col cols="3"><img       src="../assets/staticAsset/GSF_InitialStyleSketches-scientist-green.png" /></v-col>
</v-row>
 
<v-row>

    <v-col cols="12" >
      <h1 class='text-center'>Ways To Collect Medical Records</h1>
    </v-col>

</v-row>


<div class='ma-10'>
<li  class='font-weight-regular title'>You or your family member could reach out to the provider who saw the patient
and/or performed the testing and can request a copy of those records.
</li>
<li  class='font-weight-regular title'>You can then upload those records to your My Genetic Trust portal. You can
request that the provider’s office sends those records directly over to the My
Genetic Trust team by secure fax to 844 813 3892.</li>
<li  class='font-weight-regular title'>You or your family member could sign a Release of Information form that the My
Genetic Trust team can submit to the provider’s office. Once we receive those
records, we will notify you and include them in your Trust.</li>
<li  class='font-weight-regular title'>Sometimes medical records requests can take up to 30 days to process. In many
cases these records won’t be required to finalize your My Genetic Trust; they can
be added to your Trust as they come in. In some cases, it may be necessary to have
a specific medical record to finalize your My Genetic Trust; in those cases, your
Trust will be completed after the necessary records are obtained.
</li>
</div>
<p class="subtitle-2 text-center"><img  src="../assets/staticAsset/Binder.jpg" /></p>

  <h4 class='text-center'>My Genetic Trust allows for secure storage of your important health and family medical records. You can
rest assured that your sensitive information will never be sold and will only be shared with your
designated beneficiaries.</h4> 
 </v-card-text>
     </v-card>
  </v-container>
</template>

<script>
export default {
  methods : {
    downloadPDF(){
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.download = name;
      a.target = "blank";
      a.href = "https://storage.googleapis.com/genetictrust-dev.appspot.com/public/Medical%20Records%20Collection%20Guide.pdf";
      a.click();
    }
  }
}
</script>

<style>

</style>